/* RESPONSIBLE TEAM: team-omni */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    pages: {
      serialize: false,
      deserialize: 'records',
    },
  },
});
